<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8335 6.66668L12.5002 10H15.0002C15.0002 12.7583 12.7585 15 10.0002 15C9.15849 15 8.3585 14.7917 7.66683 14.4167L6.45016 15.6333C7.47516 16.2833 8.69183 16.6667 10.0002 16.6667C13.6835 16.6667 16.6668 13.6833 16.6668 10H19.1668L15.8335 6.66668ZM5.00016 10C5.00016 7.24168 7.24183 5.00001 10.0002 5.00001C10.8418 5.00001 11.6418 5.20834 12.3335 5.58334L13.5502 4.36668C12.5252 3.71668 11.3085 3.33334 10.0002 3.33334C6.31683 3.33334 3.3335 6.31668 3.3335 10H0.833496L4.16683 13.3333L7.50016 10H5.00016Z"
      fill="black"
      fill-opacity="0.54"
    />
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: '20',
    },
  },
};
</script>
